import * as React from 'react';
// eslint-disable-next-line no-restricted-imports -- This DrawerHeading component replaces the use of DrawerHeader
import { DrawerHeader, DrawerHeaderTitle, makeStyles, tokens, ToolbarButton } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { defineMessage, useIntl } from 'react-intl';
import { DrawerContext } from '../components/FoundersHubUserOverlayDrawer';
import type { DrawerNavigationOptionalProp } from '../modules/drawer';
import { DrawerNavigation } from './DrawerNavigation';

export interface DrawerHeaderProp extends DrawerNavigationOptionalProp {
  title: JSX.Element | string;
}

export function DrawerHeading({ title, onBackButtonClick, closeDrawer }: DrawerHeaderProp) {
  const classes = useStyles();
  const intl = useIntl();
  const { setShowDrawer, setChildren } = React.useContext(DrawerContext);

  function handleCloseDrawer() {
    if (closeDrawer) {
      closeDrawer();
    } else {
      setShowDrawer(false);
      setChildren(null);
    }
  }

  if (onBackButtonClick) {
    return (
      <DrawerHeader className={classes.header}>
        <DrawerNavigation closeDrawer={handleCloseDrawer} onBackButtonClick={onBackButtonClick} />
        <DrawerHeaderTitle>{title}</DrawerHeaderTitle>
      </DrawerHeader>
    );
  }

  return (
    <DrawerHeader className={classes.header}>
      <DrawerHeaderTitle
        action={
          <ToolbarButton
            appearance="subtle"
            aria-label={intl.formatMessage(closeLabel)}
            icon={<Dismiss24Regular />}
            onClick={() => handleCloseDrawer()}
            autoFocus
          />
        }
      >
        {title}
      </DrawerHeaderTitle>
    </DrawerHeader>
  );
}

const closeLabel = defineMessage({
  defaultMessage: 'Close',
  description: 'label for the close button',
});

const useStyles = makeStyles({
  header: {
    paddingBottom: tokens.spacingVerticalL,
  },
});
